export default __webpack_public_path__ + "static/pro-landing-84148382a9b0b28b551c8b50d52c75df.png";